const initHeroesTestimonials = (scope = document) => {
  if (typeof window.Swiper === 'undefined') {
    window.setTimeout(() => initHeroesTestimonials(scope), 100);
    return;
  }

  scope.querySelectorAll('[data-heroes-testimonials]').forEach((element) => {
    if (element.swiper || element.dataset.swiperInitialized === 'true') return;

    element.dataset.swiperInitialized = 'true';

    new window.Swiper(element, {
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 300,
      grabCursor: true,
      watchSlidesProgress: true,
      pagination: {
        el: element.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        750: {
          spaceBetween: 16
        }
      }
    });
  });
};

initHeroesTestimonials();


const initSocialVideoReviews = (scope = document) => {
  if (typeof window.Swiper === 'undefined') {
    window.setTimeout(() => initSocialVideoReviews(scope), 100);
    return;
  }

  scope.querySelectorAll('[data-social-video-reviews]').forEach((element) => {
    if (element.swiper || element.dataset.swiperInitialized === 'true') return;

    element.dataset.swiperInitialized = 'true';

    const pauseVideos = () => {
      element.querySelectorAll('video').forEach((video) => {
        video.pause();
      });
    };

    element.addEventListener('play', (event) => {
      if (event.target.tagName !== 'VIDEO') return;

      const media = event.target.closest('.social-video-reviews__media');
      media?.classList.add('is-playing');
      media?.querySelector('[data-social-video-play]')?.setAttribute('aria-label', 'Pause customer video');
    }, true);

    const showPlayState = (event) => {
      if (event.target.tagName !== 'VIDEO') return;

      const media = event.target.closest('.social-video-reviews__media');
      media?.classList.remove('is-playing');
      media?.querySelector('[data-social-video-play]')?.setAttribute('aria-label', 'Play customer video');
    };

    element.addEventListener('pause', showPlayState, true);
    element.addEventListener('ended', showPlayState, true);

    new window.Swiper(element, {
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 300,
      grabCursor: true,
      watchSlidesProgress: true,
      pagination: {
        el: element.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        750: {
          spaceBetween: 16
        }
      },
      on: {
        slideChangeTransitionStart: pauseVideos
      }
    });

    element.addEventListener('click', (event) => {
      const button = event.target.closest('[data-social-video-play]');
      if (!button) return;

      const media = button.closest('.social-video-reviews__media');
      const video = media?.querySelector('video');
      if (!video) return;

      if (video.paused) {
        pauseVideos();
        video.play();
      } else {
        video.pause();
      }
    });
  });
};

initSocialVideoReviews();

const initComplementaryProductSliders = (scope = document) => {
  if (typeof window.Swiper === 'undefined') {
    window.setTimeout(() => initComplementaryProductSliders(scope), 100);
    return;
  }

  scope.querySelectorAll('[data-complementary-products-slider]').forEach((element) => {
    if (element.swiper || element.dataset.swiperInitialized === 'true') return;

    element.dataset.swiperInitialized = 'true';

    new window.Swiper(element, {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 12,
      speed: 300,
      watchOverflow: true,
      pagination: {
        el: element.querySelector('.complementary-products__pagination'),
        clickable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 3.5,
          slidesPerGroup: 1,
          spaceBetween: 12
        }
      }
    });
  });
};

initComplementaryProductSliders();

const complementaryProductsObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        initComplementaryProductSliders(node.matches?.('[data-complementary-products-slider]') ? node.parentElement : node);
      }
    });
  });
});

complementaryProductsObserver.observe(document.body, {
  childList: true,
  subtree: true
});

const initProductSmilesSliders = (scope = document) => {
  if (typeof window.Swiper === 'undefined') {
    window.setTimeout(() => initProductSmilesSliders(scope), 100);
    return;
  }

  scope.querySelectorAll('[data-product-smiles-slider]').forEach((element) => {
    if (element.swiper || element.dataset.swiperInitialized === 'true') return;

    element.dataset.swiperInitialized = 'true';

    new window.Swiper(element, {
      slidesPerView: 2.15,
      spaceBetween: 8,
      watchOverflow: true,
      pagination: {
        el: element.querySelector('.product-smiles__pagination'),
        clickable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 16,
          allowTouchMove: false
        }
      }
    });
  });
};

const initDesktopThumbnailDrag = (scope = document) => {
  scope.querySelectorAll('.product--thumbnail_slider .thumbnail-list.slider--tablet-up').forEach((slider) => {
    if (slider.dataset.dragScrollInitialized === 'true') return;

    slider.dataset.dragScrollInitialized = 'true';

    let activePointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let hasDragged = false;

    slider.addEventListener('pointerdown', (event) => {
      if (!window.matchMedia('(min-width: 750px)').matches || event.button !== 0) return;

      activePointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      hasDragged = false;
    });

    slider.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointerId) return;

      const distance = event.clientX - startX;
      if (Math.abs(distance) > 5 && !hasDragged) {
        hasDragged = true;
        slider.setPointerCapture(activePointerId);
        slider.classList.add('is-dragging');
      }
      if (!hasDragged) return;

      event.preventDefault();
      slider.scrollLeft = startScrollLeft - distance;
    });

    const stopDragging = (event) => {
      if (event.pointerId !== activePointerId) return;

      if (slider.hasPointerCapture(activePointerId)) slider.releasePointerCapture(activePointerId);
      activePointerId = null;
      slider.classList.remove('is-dragging');
    };

    slider.addEventListener('pointerup', stopDragging);
    slider.addEventListener('pointercancel', stopDragging);
    slider.addEventListener('click', (event) => {
      if (!hasDragged) return;

      event.preventDefault();
      event.stopPropagation();
      hasDragged = false;
    }, true);
  });
};

const positionProductSmiles = (scope = document) => {
  scope.querySelectorAll('[id^="MainProduct-"]').forEach((section) => {
    const smiles = section.querySelector('[data-product-smiles]');
    const product = section.querySelector('.product');
    if (!smiles || !product) return;

    if (window.matchMedia('(min-width: 750px)').matches) {
      const mediaPositionRight = product.classList.contains('product--right');
      const mediaWrappers = product.querySelectorAll(':scope > .product__media-wrapper');
      const target = mediaPositionRight ? mediaWrappers[mediaWrappers.length - 1] : mediaWrappers[0];
      target?.append(smiles);
    } else {
      product.append(smiles);
    }
  });
};

initProductSmilesSliders();
initDesktopThumbnailDrag();
positionProductSmiles();

let productSmilesResizeTimer;
window.addEventListener('resize', () => {
  window.clearTimeout(productSmilesResizeTimer);
  productSmilesResizeTimer = window.setTimeout(() => positionProductSmiles(), 100);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-product-smiles-play]');
  if (!button) return;

  const media = button.closest('.product-smiles__media');
  const video = media?.querySelector('video');
  if (!video) return;

  document.querySelectorAll('.product-smiles__media video').forEach((item) => {
    if (item !== video) {
      item.pause();
      item.closest('.product-smiles__media')?.classList.remove('is-playing');
    }
  });

  if (video.paused) {
    video.play();
    media.classList.add('is-playing');
    button.setAttribute('aria-label', 'Pause customer video');
    button.blur();
  } else {
    video.pause();
    media.classList.remove('is-playing');
    button.setAttribute('aria-label', 'Play customer video');
  }
});

document.addEventListener('change', (event) => {
  const option = event.target.closest('variant-radios input[type="radio"]');
  if (!option) return;

  const selectedValue = option.closest('fieldset')?.querySelector('[data-selected-option-value]');
  if (selectedValue) selectedValue.textContent = option.value;
});

document.addEventListener('shopify:section:load', (event) => {
  initHeroesTestimonials(event.target);
  initSocialVideoReviews(event.target);
  initComplementaryProductSliders(event.target);
  initProductSmilesSliders(event.target);
  initDesktopThumbnailDrag(event.target);
  positionProductSmiles(event.target);
});
